import Header from 'features/common/components/Header'
import Navigation from 'features/common/components/Navigation'
import {
    PageContainer,
    PageContent,
    PageContentContainer,
    PageContentHeader,
    PageSidebar,
} from 'features/common/components/Page'
import {Outlet} from 'react-router-dom'

const PortalRoot = () => {
    return (
        <PageContainer>
            <PageSidebar>
                <Navigation />
            </PageSidebar>

            <PageContentContainer>
                <PageContentHeader>
                    <Header />
                </PageContentHeader>

                <PageContent>
                    <Outlet />
                </PageContent>
            </PageContentContainer>
        </PageContainer>
    )
}
export default PortalRoot
